import { useEffect, useRef } from 'react';
import { largeNumber } from '../../utils/dateHelpers';

// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
export function useInterval(callback: () => void, delay: number): void {
  const savedCallback = useRef<() => void>();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current?.();
    }
    if (delay !== null) {
      const id = setInterval(tick, Math.min(delay, largeNumber));
      return () => clearInterval(id);
    }
  }, [delay]);
}
